import PostActions from "./LikeCommentActions";
const PublicationCard = ({
  image,
  heading,

  author,
  onPreview,
  postId,
  type = "publication",
  is_Liked,
  likeCount,
  currentUserId,
  dropdownActions,
  onRemoveCollaborator,
  collaborators = [],
}) => {


  // Determine file extension
  const fileName = heading || "Document";
  const ext = image?.split(".").pop()?.toLowerCase() || "";
  let fileTypeLabel = "Document";
  if (ext === "pdf") fileTypeLabel = "PDF Document";
  else if (["doc", "docx"].includes(ext)) fileTypeLabel = "Word Document";
  else if (["xls", "xlsx"].includes(ext)) fileTypeLabel = "Excel Spreadsheet";
  else if (["ppt", "pptx"].includes(ext))
    fileTypeLabel = "PowerPoint Presentation";
  else if (["txt"].includes(ext)) fileTypeLabel = "Text File";

  const isImage = ["png", "jpg", "jpeg", "gif", "webp"].includes(ext);
  const isDoc = ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt"].includes(
    ext
  );

  return (
    <div
      className="relative bg-white cursor-pointer border border-gray-100 rounded-lg p-0  md:p-2.5 max-w-[1000px] mb-[15px]"
      onClick={() => onPreview && onPreview()}>
      {dropdownActions && (
        <div
           className=" absolute top-[-50px] right-[-30px] flex justify-end"
           >
          {dropdownActions}
        </div>
      )}

 <div
  className="w-full h-[350px] overflow-hidden rounded-md"
>
  {isImage ? (
    // ✅ Image preview
    <img
      src={image}
      alt={fileName}
      className="w-full h-full object-cover rounded-md"
    />
  ) : ext === "pdf" ? (
    // ✅ PDF preview without download toolbar
    <embed
      src={`${image}#toolbar=0&navpanes=0&scrollbar=0`}
      type="application/pdf"
      className="w-full h-full rounded-md overflow-hidden"
    />
  ) : isDoc ? (
    // ✅ Word, Excel, PPT → Google Docs Viewer
    <iframe
      src={`https://docs.google.com/gview?url=${image}&embedded=true`}
      className="w-full h-full border-0 overflow-hidden"
      title="Document Preview"
    />
  ) : (
    <em>No preview available</em>
  )}
</div>


      <div className="w-full py-3.5 mt-[8px]">
        <div
         className="font-bold text-sm overflow-hidden text-ellipsis whitespace-nowrap"
        >
          {fileName}
        </div>
        
        <div className="text-xs text-gray-500">{fileTypeLabel}</div>
        {author && (
          <div className="text-xs text-gray-800 mt-1">
            By <strong>{author}</strong>
          </div>
        )}
      </div>

      <div
        className="pt-2.5 pb-0 flex flex-col border-t border-gray-300"
        onClick={(e) => e.stopPropagation()}
      >
        <PostActions
          postId={postId}
          type={type}
          is_Liked={is_Liked === true}
          likeCount={likeCount ?? 0}
          currentUser={currentUserId}
        />
      </div>
   {collaborators.length > 0 && (
  <div className="mt-4 pt-4 border-t border-gray-100">
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <p className="text-sm font-semibold text-gray-700">Invited Collaborators</p>
    </div>
    <div className="flex flex-wrap gap-2">
      {collaborators.map((c) => (
        <div
          key={c.user_id}
          className="flex items-center gap-2 bg-slate-100 px-3 py-2 rounded-xl group hover:bg-gray-200 transition-colors"
        >
          <div className="relative">
            <img
              src={c.profile_picture}
              alt={c.name}
              className="w-8 h-8 rounded-full object-cover border-2 border-white"
            />
            <div className="absolute -bottom-1 -right-1 w-2.5 h-2.5 bg-blue-500 rounded-full border border-white"></div>
          </div>
          <span className="text-sm font-medium text-gray-900">{c.name}</span>
          {onRemoveCollaborator && (
            <button
              className="ml-1 p-1 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors opacity-0 group-hover:opacity-100"
              onClick={(e) => {
                e.stopPropagation();
                onRemoveCollaborator(postId, c.user_id);
              }}
              title="Remove collaborator"
            >
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          )}
        </div>
      ))}
    </div>
  </div>
)}

    </div>
  );
};

export default PublicationCard;
